import {
  type ICallNotification,
  type INotification
} from '@/types/INotification';

/**
 * Type guard варианта уведомления о звонке. Сужает обобщённый `INotification`
 * до `ICallNotification` по дискриминатору `type` — для выбора рендерера
 * карточки звонка в общем стеке тостов.
 *
 * @param notification - обобщённое уведомление
 * @returns `true`, если уведомление имеет тип `call`
 */
export const isCallNotification = (
  notification: INotification
): notification is ICallNotification => notification.type === 'call';
